import { AxiosResponse } from 'axios'
import { API_CLIENT_DOCUMENT_VERIFICATIONS, API_CLIENT_LATEST_DOCUMENT_VERIFICATION } from 'constants/apiUrl'
import { privateInstance } from 'services/axios/privateInstance'
import {
  IClientDocumentVerification,
  IDocumentVerificationRequest,
  IRequestDocumentVerificationParams,
} from 'typescript/interfaces/documentVerification'

export const requestDocumentVerification = ({ clientId, trigger }: IRequestDocumentVerificationParams) =>
  privateInstance.post<undefined, AxiosResponse<IDocumentVerificationRequest>>(
    API_CLIENT_DOCUMENT_VERIFICATIONS.replace(':id', clientId),
    undefined,
    {
      params: { trigger },
    }
  )

export const getLatestDocumentVerification = (clientId: string) =>
  privateInstance.get<undefined, AxiosResponse<IClientDocumentVerification>>(API_CLIENT_LATEST_DOCUMENT_VERIFICATION.replace(':id', clientId))
